const preloadWidget = async (row, funcionalidade, authorization) => {
  const payload = {
    'dataInicial': row.dataInicial,
    'dataFinal': row.dataFinal,
    'descricao': row.descricao
  }
  return createPayload(payload, funcionalidade, authorization)
}

function createPayload (detalhe, funcionalidade, authorization) {
  const payload = {
    'idFuncionalidade': funcionalidade.idFuncionalidade,
    'data': {
      ...detalhe
    },
    'configuracao': {
      'parametros': {},
      'metodoEnvio': []
    },
    'opcoesDeEnvio': []
  }
  if (funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioChatWidget) {
    payload.configuracao.metodoEnvio.push({
      'tipo': {
        'id': 1,
        'descricao': 'Mensagem no chat'
      },
      'sincrono': true
    })
  }
  if (funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioEmailWidget && funcionalidade.parametros.configuracoesDeWidgets.templateEnvioEmailWidget) {
    payload.configuracao.metodoEnvio.push({
      'tipo': {
        'id': 2,
        'descricao': 'E-mail'
      },
      'template': funcionalidade.parametros.configuracoesDeWidgets.templateEnvioEmailWidget,
      'sincrono': false
    })
  }
  if (funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioWhatsappWidget && funcionalidade.parametros.configuracoesDeWidgets.templateEnvioWhatsappWidget) {
    payload.configuracao.metodoEnvio.push({
      'tipo': {
        'id': 3,
        'descricao': 'WhatsApp'
      },
      'template': funcionalidade.parametros.configuracoesDeWidgets.templateEnvioWhatsappWidget,
      'sincrono': false
    })
  }
  payload.opcoesDeEnvio.push({
    'nome': 'Extrato Coparticipação em PDF',
    'nomeIntegracao': 'extratoPdf',
    'integracao': {
      'headers': {
        'Authorization': authorization
      },
      'parametros': {},
      'rota': {
        ...funcionalidade.rotas.extratoPdf
      },
      'payload': {
        'dataInicial': detalhe.dataInicial,
        'dataFinal': detalhe.dataFinal
      }
    },
    'data': {
      'tituloWidget': `${funcionalidade.nome}`
    }
  })
  return payload
}
export { preloadWidget }
